<form class="ui-g form-style" #registerForm="ngForm">
    <div>
        <div class="r-form-group ">
            <label class="title" for="businessName">{{'REGISTER.BUSINESS_NAME' | translate}}</label>
            <input type="text" name="businessName" #businessName="ngModel" [(ngModel)]="registerModel.businessName"
                required maxlength="100">
            <div *ngIf="registerForm.submitted || businessName.touched">
                <div *ngIf="businessName.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="businessName?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 100
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="justify-content: space-between;">

        <div class="r-form-group" style="width: 48%;">
            <label class="title" for="country">{{'REGISTER.COUNTRY' | translate}}</label>
            <p-autoComplete *ngIf="allCountries?.length>0" [suggestions]="countries" name="country" #country="ngModel"
                [(ngModel)]="registerModel.country" [dropdown]="true" (completeMethod)="filterCountries($event)"
                dropdownMode="current" [maxlength]="30" [required]="true">
            </p-autoComplete>
            <input *ngIf="!allCountries?.length" type="text" name="country" #country="ngModel"
                [(ngModel)]="registerModel.country" [maxlength]="30" [required]="true" />

            <div *ngIf="registerForm.submitted || registerForm.controls['country']?.touched">
                <div *ngIf="registerForm.controls['country']?.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="registerForm.controls['country']?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 30
                </div>
            </div>
        </div>
        <div class="r-form-group autocomplete" style="width: 48%;">
            <label class="title" for="city">{{'REGISTER.CITY' | translate}}</label>
            <p-autoComplete *ngIf="allCities?.length>0" name="city" [(ngModel)]="registerModel.city" #city="ngModel"
                [suggestions]="cities" [dropdown]="true" (completeMethod)="filterCities($event)" dropdownMode="current"
                [maxlength]="30" [required]="true">
            </p-autoComplete>
            <input *ngIf="!allCities?.length" type="text" name="city" #city="ngModel" [(ngModel)]="registerModel.city"
                [maxlength]="30" [required]="true" />

            <div *ngIf="registerForm.submitted || registerForm.controls['city']?.touched">
                <div *ngIf="registerForm.controls['city']?.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="registerForm.controls['city']?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 30
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="street">{{'REGISTER.STREET' | translate}}</label>
            <input type="text" name="street" #street="ngModel" [(ngModel)]="registerModel.address" required
                maxlength="300">
            <div *ngIf="registerForm.submitted || street.touched">
                <div *ngIf="street.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="street?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 300
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="phone">{{'REGISTER.PHONE' | translate}}</label>
            <input type="text" name="phone" #phone="ngModel" [(ngModel)]="registerModel.phone" required minlength="9"
                maxlength="10">
            <div *ngIf="registerForm.submitted || phone.touched">
                <div *ngIf="phone.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="phone?.errors?.minlength" class="error">
                    {{'ERRORS.MIN_LENGTH' | translate}} 9
                </div>
                <div *ngIf="phone?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 10
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="category">{{'REGISTER.BUSINESS_AERA' | translate}}</label>
            <p-dropdown name="category" [appendTo]="null" [options]="allCategories" [(ngModel)]="selectedCategory"
                #category="ngModel" optionLabel="label" (onChange)="selectCategory()" [filter]="true" filterBy="label"
                placeholder="{{'REGISTER.CHOOSE_BUSINESS_AREA' | translate}}" [showClear]="true">
            </p-dropdown>

            <div *ngIf="category.errors?.required && (registerForm.submitted||category.touched)" class="error">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="businessCategory[this.registerModel.category]==businessCategory[businessCategory.other]"
            class="r-form-group ">
            <input type="text" name="details" #details="ngModel" [(ngModel)]="registerModel.details" maxlength="200"
                placeholder="{{'REGISTER.ENTER_BUSINESS_AREA' | translate}}">
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="website">{{'REGISTER.WEBSITE' | translate}}</label>
            <input type="text" name="website" #website="ngModel" [(ngModel)]="registerModel.webSite" maxlength="200">
        </div>
        <div *ngIf="website?.errors?.maxlength && (registerForm.submitted||website.touched)" class="error">
            {{'ERRORS.MAX_LENGTH' | translate}} 200
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="essence">{{'REGISTER.OWNER_FULL_NAME' | translate}}</label>
            <input type="text" name="essence" #essence="ngModel" [(ngModel)]="registerModel.ownerFullName " required
                maxlength="100">
        </div>
        <div *ngIf="essence?.errors?.maxlength && (registerForm.submitted||essence.touched)" class="error">
            {{'ERRORS.MAX_LENGTH' | translate}} 50
        </div>
        <div *ngIf="registerForm.submitted || essence.touched">
            <div *ngIf="businessName.errors?.required" class="error">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
            <div *ngIf="businessName?.errors?.maxlength" class="error">
                {{'ERRORS.MAX_LENGTH' | translate}} 100
            </div>
        </div>

    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="language">{{'REGISTER.LANGUAGE' | translate}}</label>
            <p-dropdown name="language" #language="ngModel" [appendTo]="null" [(ngModel)]="registerModel.language"
                [options]="languages" class="langDrop">
                <ng-template pTemplate="selectedItem">
                    {{registerModel.language|enumTranslate:lang}}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{item|enumTranslate:lang}}
                </ng-template>
            </p-dropdown>
            <div *ngIf="language.errors?.required && language.touched" class="error">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
    </div>
    <div class="r-form-group">
        <div class="row">
            <input class="agreeInput" name="check" type="checkbox" [(ngModel)]="registerModel.Agreemant"
                #agree="ngModel" required>
            <a class="link" (click)="displayAgreement()">{{'REGISTER.AGREE_TERMS' |
                translate}}</a>
        </div>
        <div *ngIf="agree.errors?.required &&(registerForm.submitted|| agree.touched)" class="error">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>
    <div class="google-button-container">
        <div id="googleRegisterButton"></div>
        <button *ngIf="registerForm.invalid" class="overlay" (click)="registerByGoogle()"></button>
    </div>
    <div class="form-center-header">
        <div class="line"></div>
        <div class="text"><span>{{'REGISTER.REGISTER_EMAIL_PASSWORD' | translate}}</span></div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="email">{{'REGISTER.EMAIL' | translate}}</label>
            <input type="text" name="email" #email="ngModel" [(ngModel)]="registerModel.email" maxlength="100"
                autocomplete="new-email" email>
            <div *ngIf="registerForm.submitted || email.touched">
                <div *ngIf="email.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="email?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 100
                </div>
                <div *ngIf="email?.errors?.email" class="error">
                    {{'ERRORS.EMAIL' | translate}}
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="password">{{'REGISTER.PASSWORD' | translate}}</label>
            <input type="password" name="password" #password="ngModel" [(ngModel)]="registerModel.password"
                (keyup)="checkPasswordMatch()" autocomplete="new-password" maxlength="100">
            <div *ngIf="registerForm.submitted || password.touched">

                <div *ngIf="password.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="password?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 100
                </div>

            </div>
        </div>
    </div>
    <div>
        <div class="r-form-group ">
            <label class="title" for="confirm_password">{{'REGISTER.RETURN_PASSWORD' | translate}}</label>
            <input type="password" name="confirm_password" #confirm_password="ngModel" [(ngModel)]="confirmPassword"
                (keyup)="checkPasswordMatch()" reverse>
            <div *ngIf="registerForm.submitted || confirm_password.touched">
                <div *ngIf="confirm_password.errors?.required " class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
            </div>
            <div class="error" *ngIf="registerForm.controls['confirm_password']?.errors?.mustMatch">
                {{'ERRORS.MUST_MATCH' | translate}}
            </div>
        </div>
    </div>

    <button class="command-button full full-width" type="submit" blockButtonToSingleClick
        (click)="sendRegisterForm()">{{'REGISTER.REGISTER' |
        translate}}</button>
</form>

<p-dialog [(visible)]="displayWebGameAgreement" [style]="{'width': 'min(900px, 92vw)'}" styleClass="agreement-dialog" appendTo="body" [baseZIndex]="10000">
    <div class="iframeWrapper">
        <iframe *ngIf="currentLang === lang.he" class="pdfViewer" src="assets/docs/TETMS_OF_SERVICE-he.html" frameborder="0"></iframe>
        <iframe *ngIf="currentLang !== lang.he" class="pdfViewer" src="assets/docs/TERMS_OF_SERVICE-en.html" frameborder="0"></iframe>
    </div>
    <div class="agreement-footer">
        <p-button icon="pi pi-check" styleClass="p-button-text" (click)="agreeTerms()" [label]="'REGISTER.IAGREE' | translate"></p-button>
    </div>
</p-dialog>